
import React from "react";
import { CSVLink } from "react-csv";
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';


function DownloadCountryPoliciesResponses(props) {

    const { t } = useTranslation();
   // console.log("data in download");
   //console.log(props.data);

const columns = [
{label : `A.1.1 ${t('indicator_A_11')}`, key: "indicator_A_11"},
{label : `A.1.1 ${t('table_heading_est')}`, key: "year_indicator_A_11"},
{label : `A.1.1 ${t('table_heading_areas')}`, key: "area_indicator_A_11"},
{label : `A.1.2 ${t('indicator_A_12')}`, key: "indicator_A_12"},
{label : `A.1.2 ${t('table_heading_est')}`, key: "year_indicator_A_12"},
{label : `A.1.2 ${t('table_heading_areas')}`, key: "area_indicator_A_12"},
{label : `A.2.1 ${t('indicator_A_21')}`, key: "indicator_A_21"},
{label : `A.2.1 ${t('table_heading_est')}`, key: "year_indicator_A_21"},
{label : `A.2.1 ${t('table_heading_areas')}`, key: "area_indicator_A_21"},
{label : `A.2.2 ${t('indicator_A_22')}`, key: "indicator_A_22"},
{label : `A.2.2 ${t('table_heading_est')}`, key: "year_indicator_A_22"},
{label : `A.2.2 ${t('table_heading_areas')}`, key: "area_indicator_A_22"},
{label : `A.3.1 ${t('indicator_A_31')}`, key: "indicator_A_31"},
{label : `A.3.1 ${t('table_heading_est')}`, key: "year_indicator_A_31"},
{label : `A.3.2 ${t('indicator_A_32')}`, key: "indicator_A_32"},
{label : `A.3.2 ${t('table_heading_areas')}`, key: "area_indicator_A_32"},
{label : `A.3.3 ${t('indicator_A_33')}`, key: "indicator_A_33"},
{label : `A.3.3 ${t('table_heading_est')}`, key: "year_indicator_A_33"},
{label : `A.3.3 ${t('table_heading_areas')}`, key: "area_indicator_A_33"},
{label : `A.4.1 ${t('indicator_A_41')}`, key: "indicator_A_41"},
{label : `A.4.1 ${t('table_heading_est')}`, key: "year_indicator_A_41"},
{label : `A.4.1 ${t('table_heading_areas')}`, key: "area_indicator_A_41"},
{label : `A.4.2 ${t('indicator_A_42')}`, key: "indicator_A_42"},
{label : `A.4.2 ${t('table_heading_est')}`, key: "year_indicator_A_42"},
{label : `A.4.2 ${t('table_heading_areas')}`, key: "area_indicator_A_43"},
{label : `A.4.3 ${t('indicator_A_43')}`, key: "indicator_A_43"},
{label : `B.4.1.1 ${t('indicator_B_4_1_1')}`, key: "indicator_B_4_1_1"},
{label : `B.4.1.2 ${t('indicator_B_4_1_2')}`, key: "indicator_B_4_1_2"},
{label : `B.4.1.3.${t('indicator_B_4_1_3')}`, key: "indicator_B_4_1_3"},
{label : `B.4.2 ${t('indicator_B_42')}`, key: "indicator_B_42"},
{label : `B.4.2 ${t('menu_item_networks')}`, key: "networks"},
{label : `B.4.3 ${t('indicator_B_43')}`, key: "indicator_B_43"},
{label : `B.4.3 ${t('title_organization')}`, key: "organizations"},
];


const multiCountryColumns = props.page === "allData" ? 
[
  {label : `${t('title_region')}`, key: "region"},
  {label : `${t('title_country')}`, key: "country"},
  {label : `A.1.1 ${t('indicator_A_11')}`, key: "indicator_A_11"},
  {label : `A.1.1 ${t('table_heading_est')}`, key: "year_indicator_A_11"},
  {label : `A.1.1 ${t('table_heading_areas')}`, key: "area_indicator_A_11"},
  {label : `A.1.2 ${t('indicator_A_12')}`, key: "indicator_A_12"},
  {label : `A.1.2 ${t('table_heading_est')}`, key: "year_indicator_A_12"},
  {label : `A.1.2 ${t('table_heading_areas')}`, key: "area_indicator_A_12"},
  {label : `A.2.1 ${t('indicator_A_21')}`, key: "indicator_A_21"},
  {label : `A.2.1 ${t('table_heading_est')}`, key: "year_indicator_A_21"},
  {label : `A.2.1 ${t('table_heading_areas')}`, key: "area_indicator_A_21"},
  {label : `A.2.2 ${t('indicator_A_22')}`, key: "indicator_A_22"},
  {label : `A.2.2 ${t('table_heading_est')}`, key: "year_indicator_A_22"},
  {label : `A.2.2 ${t('table_heading_areas')}`, key: "area_indicator_A_22"},
  {label : `A.3.1 ${t('indicator_A_31')}`, key: "indicator_A_31"},
  {label : `A.3.1 ${t('table_heading_est')}`, key: "year_indicator_A_31"},
  {label : `A.3.2 ${t('indicator_A_32')}`, key: "indicator_A_32"},
  {label : `A.3.2 ${t('table_heading_areas')}`, key: "area_indicator_A_32"},
  {label : `A.3.3 ${t('indicator_A_33')}`, key: "indicator_A_33"},
  {label : `A.3.3 ${t('table_heading_est')}`, key: "year_indicator_A_33"},
  {label : `A.3.3 ${t('table_heading_areas')}`, key: "area_indicator_A_33"},
  {label : `A.4.1 ${t('indicator_A_41')}`, key: "indicator_A_41"},
  {label : `A.4.1 ${t('table_heading_est')}`, key: "year_indicator_A_41"},
  {label : `A.4.1 ${t('table_heading_areas')}`, key: "area_indicator_A_41"},
  {label : `A.4.2 ${t('indicator_A_42')}`, key: "indicator_A_42"},
  {label : `A.4.2 ${t('table_heading_est')}`, key: "year_indicator_A_42"},
  {label : `A.4.2 ${t('table_heading_areas')}`, key: "area_indicator_A_43"},
  {label : `A.4.3 ${t('indicator_A_43')}`, key: "indicator_A_43"},
  {label : `B.4.1.1 ${t('indicator_B_4_1_1')}`, key: "indicator_B_4_1_1"},
  {label : `B.4.1.2 ${t('indicator_B_4_1_2')}`, key: "indicator_B_4_1_2"},
  {label : `B.4.1.3.${t('indicator_B_4_1_3')}`, key: "indicator_B_4_1_3"},
  {label : `B.4.2 ${t('indicator_B_42')}`, key: "indicator_B_42"},
  {label : `B.4.2 ${t('menu_item_networks')}`, key: "networks"},
  {label : `B.4.3 ${t('indicator_B_43')}`, key: "indicator_B_43"},
  {label : `B.4.3 ${t('title_organization')}`, key: "organizations"},
  ] : [];
 

  const multiCountryDowloadableData = props.page === "allData" && props.data !== undefined && props.data.length > 0 ?
    props.data.map((item) => ({
    region:  `${item.territory.region.name}`,
    country:  `${item.territory.name} - ${item.territory.iso3}`,
    indicator_A_11 : item.answers.filter(ans => ans.question === 5).length > 0 ? 
    item.answers.filter(ans => ans.question === 5)[0].value === "0" ? 
   `${t('legend_yes')}` : 
    item.answers.filter(ans => ans.question === 5)[0].value === "1" ? 
   `${t('legend_initiated')}` : 
   item.answers.filter(ans => ans.question === 5)[0].value === "2" ? `${t('legend_no')}` 
   : `${t('legend_not_available')}` 
   : `${t('legend_not_available')}`,
     
   year_indicator_A_11: item.answers.filter(ans => ans.question === 7).length > 0 ? 
   item.answers.filter(ans => ans.question === 7)[0].value : "",
     
     area_indicator_A_11:  item.answers.filter(ans => ans.question === 8).length > 0 ? 
     item.answers.filter(ans => ans.question === 8).length === 1 ?
     item.answers.filter(ans => ans.question === 8)[0].value === "0" ? 
     `${t('result_conservation_FGR')}` : 
     item.answers.filter(ans => ans.question === 8)[0].value === "1" ? 
      `${t('result_production_fores')}` :
      item.answers.filter(ans => ans.question === 8)[0].value === "2" ?
      `${t('result_FGR_transferred')}` : 
      item.answers.filter(ans => ans.question === 8)[0].value  === "3" ? 
    `${t('result_research_dev')}` :
    item.answers.filter(ans => ans.question === 8)[0].value === "4" ? `${t('result_other')}` : "" :
    item.answers.filter(ans => ans.question === 8).sort((a, b) => a.value - b.value).map((res) => 
    res.value === "0" ? 
   `${t('result_conservation_FGR')}` : 
     res.value === "1" ? 
     `${t('result_production_fores')}` :
      res.value === "2" ?
      `${t('result_FGR_transferred')}` : 
     res.value  === "3" ? 
     `${t('result_research_dev')}` : 
     `${t('result_other')}`).join(" - ")
      : "",
     
     indicator_A_12: item.answers.filter(ans => ans.question === 19).length > 0 ? 
     item.answers.filter(ans => ans.question === 19)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 19)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 19)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     year_indicator_A_12: item.answers.filter(ans => ans.question === 21).length > 0 ? 
     item.answers.filter(ans => ans.question === 21)[0].value : "",
     
     area_indicator_A_12: item.answers.filter(ans => ans.question === 22).length > 0 ? 
     item.answers.filter(ans => ans.question === 22).length === 1 ?
     item.answers.filter(ans => ans.question === 22)[0].value === "0" ? 
     `${t('result_conservation_FGR')}` : 
     item.answers.filter(ans => ans.question === 22)[0].value === "1" ? 
      `${t('result_production_fores')}` :
      item.answers.filter(ans => ans.question === 22)[0].value === "2" ?
      `${t('result_FGR_transferred')}` : 
      item.answers.filter(ans => ans.question === 22)[0].value  === "3" ? 
    `${t('result_research_dev')}` :
    item.answers.filter(ans => ans.question === 22)[0].value === "4" ? `${t('result_other')}` : "" :
    item.answers.filter(ans => ans.question === 22).sort((a, b) => a.value - b.value).map((res) => 
    res.value === "0" ? 
   `${t('result_conservation_FGR')}` : 
     res.value === "1" ? 
     `${t('result_production_fores')}` :
      res.value === "2" ?
      `${t('result_FGR_transferred')}` : 
     res.value  === "3" ? 
     `${t('result_research_dev')}` : 
     `${t('result_other')}`).join(" - ")
    
    : "",
     
     indicator_A_21: item.answers.filter(ans => ans.question === 34).length > 0 ? 
     item.answers.filter(ans => ans.question === 34)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 34)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 34)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     year_indicator_A_21: item.answers.filter(ans => ans.question === 36).length > 0 ? 
     item.answers.filter(ans => ans.question === 36)[0].value : "",
     
     area_indicator_A_21: item.answers.filter(ans => ans.question === 37).length > 0 ? 

     item.answers.filter(ans => ans.question === 37).length === 1 ? 
     item.answers.filter(ans => ans.question === 37)[0].value === "0" ? 
     `${t('result_in_situ_conservation')}` : 
     item.answers.filter(ans => ans.question === 37)[0].value === "1" ? 
      `${t('result_protected_areas')}` :
      item.answers.filter(ans => ans.question === 37)[0].value === "2" ?
      `${t('result_forests_managed')}` : 
      item.answers.filter(ans => ans.question === 37)[0].value  === "3" ? 
     `${t('result_other')}` : "" : 
     item.answers.filter(ans => ans.question === 37).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
     `${t('result_in_situ_conservation')}`: 
          res.value === "1" ? 
          `${t('result_protected_areas')}` :
           res.value === "2" ?
           `${t('result_forests_managed')}`: 
           `${t('result_other')}`).join(" - ")  : "",
     
     indicator_A_22: item.answers.filter(ans => ans.question === 47).length > 0 ? 
     item.answers.filter(ans => ans.question === 47)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 47)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 47)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     year_indicator_A_22: item.answers.filter(ans => ans.question === 49).length > 0 ? 
     item.answers.filter(ans => ans.question === 49)[0].value : "",
 
     area_indicator_A_22: item.answers.filter(ans => ans.question === 50).length > 0 ? 
     item.answers.filter(ans => ans.question === 50).length === 1 ? 
     item.answers.filter(ans => ans.question === 50)[0].value === "0" ? 
     `${t('result_ex_situ_conservation')}` : 
     item.answers.filter(ans => ans.question === 50)[0].value === "1" ? 
      `${t('result_field_collections')}` :
      item.answers.filter(ans => ans.question === 50)[0].value === "2" ?
      `${t('result_storage_facilities')}` : 
      item.answers.filter(ans => ans.question === 50)[0].value  === "3" ? 
     `${t('result_other')}` : "" : 
     item.answers.filter(ans => ans.question === 50).sort((a, b) => a.value - b.value).map((res) => 
     res.value === "0" ? 
    `${t('result_ex_situ_conservation')}` : 
      res.value === "1" ? 
      `${t('result_field_collections')}` :
       res.value === "2" ?
       `${t('result_FGR_transferred')}` : 
      res.value  === "3" ? 
      `${t('result_other')}` : 
      "").join(" - "): "",
     
     indicator_A_31: item.answers.filter(ans => ans.question === 61).length > 0 ? 
     item.answers.filter(ans => ans.question === 61)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 61)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 61)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     year_indicator_A_31: item.answers.filter(ans => ans.question === 63).length > 0 ? 
     item.answers.filter(ans => ans.question === 63)[0].value : "",
    
     
     indicator_A_32: item.answers.filter(ans => ans.question === 69).length > 0 ? 
     item.answers.filter(ans => ans.question === 69)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 69)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 69)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     
     area_indicator_A_32: item.answers.filter(ans => ans.question === 71).length > 0 ? 
     item.answers.filter(ans => ans.question === 71).length === 1 ? 
     item.answers.filter(ans => ans.question === 71)[0].value === "0" ? 
     `${t('result_public_entities')}` : 
     item.answers.filter(ans => ans.question === 71)[0].value === "1" ? 
      `${t('result_private_companies')}` :
      item.answers.filter(ans => ans.question === 71)[0].value === "2" ?
      `${t('result_private_public_partnerships')}` : 
      item.answers.filter(ans => ans.question === 71)[0].value  === "3" ? 
     `${t('result_other')}` : "" :
     
     item.answers.filter(ans => ans.question === 71).filter(ans => ans.question === 71).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
     `${t('result_public_entities')}` : 
          res.value === "1" ? 
          `${t('result_private_companies')}` :
           res.value === "2" ?
           `${t('result_private_public_partnerships')}` : 
           `${t('result_other')}` ).join(" - ") : "",
     
     indicator_A_33: item.answers.filter(ans => ans.question === 81).length > 0 ? 
     item.answers.filter(ans => ans.question === 81)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 81)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 81)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     year_indicator_A_33: item.answers.filter(ans => ans.question === 83).length > 0 ? 
     item.answers.filter(ans => ans.question === 83)[0].value : "",
    
     area_indicator_A_33: 
     item.answers.filter(ans => ans.question === 84).length > 0 ? 
     item.answers.filter(ans => ans.question === 84).length === 1 ? 
     item.answers.filter(ans => ans.question === 84)[0].value === "0" ? 
     `${t('result_farmers')}` : 
     item.answers.filter(ans => ans.question === 84)[0].value === "1" ? 
      `${t('result_local_communities')}` :
      item.answers.filter(ans => ans.question === 84)[0].value === "2" ?
      `${t('result_forest_owners')}` : 
      item.answers.filter(ans => ans.question === 84)[0].value  === "3" ? 
     `${t('result_other_stakeholders')}` : "" :
     item.answers.filter(ans => ans.question === 84).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
     `${t('result_farmers')}` : 
          res.value === "1" ? 
          `${t('result_local_communities')}` :
           res.value === "2" ?
           `${t('result_forest_owners')}` : 
           `${t('result_other_stakeholders')}`).join(" - ")
     
     : "",
     
     indicator_A_41: item.answers.filter(ans => ans.question === 95).length > 0 ? 
     item.answers.filter(ans => ans.question === 95)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 95)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 95)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     
     year_indicator_A_41 : item.answers.filter(ans => ans.question === 97).length > 0 ? 
     item.answers.filter(ans => ans.question === 97)[0].value : "",
     
     area_indicator_A_41 : item.answers.filter(ans => ans.question === 98).length > 0 ?
     item.answers.filter(ans => ans.question === 98).length === 1 ? 
     item.answers.filter(ans => ans.question === 98)[0].value === "0" ? 
     `${t('result_farmers')}` : 
     item.answers.filter(ans => ans.question === 98)[0].value === "1" ? 
      `${t('result_forest_owners')}` :
      item.answers.filter(ans => ans.question === 98)[0].value === "2" ?
      `${t('result_private_sector')}` : 
      item.answers.filter(ans => ans.question === 98)[0].value  === "3" ? 
     `${t('result_NGO')}` : 
     item.answers.filter(ans => ans.question === 98)[0].value === "4" ? 
     `${t('result_gov_org')}` : 
     item.answers.filter(ans => ans.question === 98)[0].value === "5" ? 
      `${t('result_research_org')}` :
      item.answers.filter(ans => ans.question === 98)[0].value === "6" ?
      `${t('result_relevant_ministries')}` :
      item.answers.filter(ans => ans.question === 98)[0].value === "7" ?
      `${t('result_other_stakeholders')}` :
      "" : item.answers.filter(ans => ans.question === 98).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
      `${t('result_farmers')}` : 
     res.value === "1" ? 
     `${t('result_forest_owners')}` :
      res.value === "2" ?
      `${t('result_private_sector')}` : 
     res.value === "3" ?
     `${t('result_NGO')}` :
      res.value === "4" ?
      `${t('result_gov_org')}` :
      res.value === "5" ?
      `${t('result_research_org')}` :
      res.value === "6" ?
      `${t('result_relevant_ministries')}` :
      `${t('result_other_stakeholders')}`
       ).join(" - ") : "",
     
     indicator_A_42: item.answers.filter(ans => ans.question === 112).length > 0 ? 
     item.answers.filter(ans => ans.question === 112)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 112)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 112)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     year_indicator_A_42: item.answers.filter(ans => ans.question === 114).length > 0 ? 
     item.answers.filter(ans => ans.question === 114)[0].value : "",
 
     area_indicator_A_43: item.answers.filter(ans => ans.question === 115).length > 0 ? 
     item.answers.filter(ans => ans.question === 115).length === 1 ? 
     item.answers.filter(ans => ans.question === 115)[0].value === "0" ? 
     `${t('result_conservation_FGR')}` : 
     item.answers.filter(ans => ans.question === 115)[0].value === "1" ? 
      `${t('result_use_FGR')}` :
      item.answers.filter(ans => ans.question === 115)[0].value === "2" ?
      `${t('result_development_FGR')}` : "" :
      item.answers.filter(ans => ans.question === 115).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
      `${t('result_conservation_FGR')}` : 
          res.value === "1" ? 
          `${t('result_use_FGR')}` :
          `${t('result_development_FGR')}`
            ).join(" - ")
      : "",
     
     indicator_A_43: item.answers.filter(ans => ans.question === 124).length > 0 ? 
     item.answers.filter(ans => ans.question === 124)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 124)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 124)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     
     indicator_B_4_1_1: item.answers.filter(ans => ans.question === 191).length > 0 ? 
     item.answers.filter(ans => ans.question === 191)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 191)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 191)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
 
     indicator_B_4_1_2: item.answers.filter(ans => ans.question === 198).length > 0 ? 
     item.answers.filter(ans => ans.question === 198)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 198)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 198)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
 
     indicator_B_4_1_3: item.answers.filter(ans => ans.question === 205).length > 0 ? 
     item.answers.filter(ans => ans.question === 205)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 205)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 205)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
 
     indicator_B_42: item.answers.filter(ans => ans.question === 213).length > 0 ? 
     item.answers.filter(ans => ans.question === 213)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 213)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 213)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
 
 
     networks: item.answers.filter(ans => ans.question === 215).length > 0 ? 
     item.answers.filter(ans => ans.question === 215)[0].value : "",
     indicator_B_43: item.answers.filter(ans => ans.question === 221).length > 0 ? 
     item.answers.filter(ans => ans.question === 221)[0].value === "0" ? 
     `${t('legend_yes')}` : 
     item.answers.filter(ans => ans.question === 221)[0].value === "1" ? 
     `${t('legend_initiated')}` : 
     item.answers.filter(ans => ans.question === 221)[0].value === "2" ? `${t('legend_no')}` 
     : `${t('legend_not_available')}` 
     : `${t('legend_not_available')}`,
     organizations: item.answers.filter(ans => ans.question === 223).length > 0 ? 
     item.answers.filter(ans => ans.question === 223)[0].value : "",
           })) : [];



const dowloadableData = props.data !== undefined && props.data.length > 0 ?
 [{ 
  indicator_A_11 : props.data.filter(ans => ans.question === 5).length > 0 ? 
  props.data.filter(ans => ans.question === 5)[0].value === "0" ? 
  `${t('legend_yes')}` : 
  props.data.filter(ans => ans.question === 5)[0].value === "1" ? 
  `${t('legend_initiated')}` : 
  props.data.filter(ans => ans.question === 5)[0].value === "2" ? `${t('legend_no')}` 
  : `${t('legend_not_available')}` 
  : `${t('legend_not_available')}`,
    
  year_indicator_A_11: props.data.filter(ans => ans.question === 7).length > 0 ? 
    props.data.filter(ans => ans.question === 7)[0].value : "",
    
    area_indicator_A_11:   props.data.filter(ans => ans.question === 8).length > 0 ? 
    props.data.filter(ans => ans.question === 8).length === 1 ?
    props.data.filter(ans => ans.question === 8)[0].value === "0" ? 
    `${t('result_conservation_FGR')}` : 
    props.data.filter(ans => ans.question === 8)[0].value === "1" ? 
     `${t('result_production_fores')}` :
     props.data.filter(ans => ans.question === 8)[0].value === "2" ?
     `${t('result_FGR_transferred')}` : 
     props.data.filter(ans => ans.question === 8)[0].value  === "3" ? 
   `${t('result_research_dev')}` :
   props.data.filter(ans => ans.question === 8)[0].value === "4" ? `${t('result_other')}` : "" :
   props.data.filter(ans => ans.question === 8).sort((a, b) => a.value - b.value).map((res) => 
     res.value === "0" ? 
    `${t('result_conservation_FGR')}` : 
      res.value === "1" ? 
      `${t('result_production_fores')}` :
       res.value === "2" ?
       `${t('result_FGR_transferred')}` : 
      res.value  === "3" ? 
      `${t('result_research_dev')}` : 
      `${t('result_other')}`).join(" - ")
     : "",
    indicator_A_12: props.data.filter(ans => ans.question === 19).length > 0 ? 
    props.data.filter(ans => ans.question === 19)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 19)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 19)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    year_indicator_A_12: props.data.filter(ans => ans.question === 21).length > 0 ? 
    props.data.filter(ans => ans.question === 21)[0].value : "",
    
    area_indicator_A_12: props.data.filter(ans => ans.question === 22).length > 0 ? 

    props.data.filter(ans => ans.question === 22).length === 1 ? 
    props.data.filter(ans => ans.question === 22)[0].value === "0" ? 
    `${t('result_conservation_FGR')}` : 
     props.data.filter(ans => ans.question === 22)[0].value === "1" ? 
     `${t('result_production_fores')}` :
     props.data.filter(ans => ans.question === 22)[0].value === "2" ?
     `${t('result_FGR_transferred')}` : 
   props.data.filter(ans => ans.question === 22)[0].value  === "3" ? 
   `${t('result_research_dev')}` :
    props.data.filter(ans => ans.question === 22)[0].value === "4" ? `${t('result_other')}` : "" :
    
    props.data.filter(ans => ans.question === 22).sort((a, b) => a.value - b.value).map((res) => 
    res.value === "0" ? 
   `${t('result_conservation_FGR')}` : 
     res.value === "1" ? 
     `${t('result_production_fores')}` :
      res.value === "2" ?
      `${t('result_FGR_transferred')}` : 
     res.value  === "3" ? 
     `${t('result_research_dev')}` : 
     `${t('result_other')}`).join(" - ")
    : "",
    
    indicator_A_21: props.data.filter(ans => ans.question === 34).length > 0 ? 
    props.data.filter(ans => ans.question === 34)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 34)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 34)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    year_indicator_A_21: props.data.filter(ans => ans.question === 36).length > 0 ? 
    props.data.filter(ans => ans.question === 36)[0].value : "",
    
    area_indicator_A_21: props.data.filter(ans => ans.question === 37).length > 0 ? 
    props.data.filter(ans => ans.question === 37).length === 1 ? 
    props.data.filter(ans => ans.question === 37)[0].value === "0" ? 
    `${t('result_in_situ_conservation')}` : 
     props.data.filter(ans => ans.question === 37)[0].value === "1" ? 
     `${t('result_protected_areas')}` :
     props.data.filter(ans => ans.question === 37)[0].value === "2" ?
     `${t('result_forests_managed')}` : 
   props.data.filter(ans => ans.question === 37)[0].value  === "3" ? 
    `${t('result_other')}` : "" : 
    props.data.filter(ans => ans.question === 37).sort((a, b) => a.value - b.value).map((res) => 
    res.value === "0" ? 
   `${t('result_conservation_FGR')}` : 
     res.value === "1" ? 
     `${t('result_production_fores')}` :
      res.value === "2" ?
      `${t('result_FGR_transferred')}` : 
     res.value  === "3" ? 
     `${t('result_research_dev')}` : 
     `${t('result_other')}`).join(" - ") : "",
    
    indicator_A_22: props.data.filter(ans => ans.question === 47).length > 0 ? 
    props.data.filter(ans => ans.question === 47)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 47)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 47)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    year_indicator_A_22: props.data.filter(ans => ans.question === 49).length > 0 ? 
    props.data.filter(ans => ans.question === 49)[0].value : "",

    area_indicator_A_22: props.data.filter(ans => ans.question === 50).length > 0 ?
    props.data.filter(ans => ans.question === 50).length === 1 ? 
    props.data.filter(ans => ans.question === 50)[0].value === "0" ? 
    `${t('result_ex_situ_conservation')}` : 
     props.data.filter(ans => ans.question === 50)[0].value === "1" ? 
     `${t('result_field_collections')}` :
     props.data.filter(ans => ans.question === 50)[0].value === "2" ?
     `${t('result_storage_facilities')}` : 
   props.data.filter(ans => ans.question === 50)[0].value  === "3" ? 
    `${t('result_other')}` : "" :
    props.data.filter(ans => ans.question === 50).sort((a, b) => a.value - b.value).map((res) => 
    res.value === "0" ? 
   `${t('result_ex_situ_conservation')}` : 
     res.value === "1" ? 
     `${t('result_field_collections')}` :
      res.value === "2" ?
      `${t('result_FGR_transferred')}` : 
     res.value  === "3" ? 
     `${t('result_other')}` : 
     "").join(" - ")
    
    : "",
    
    indicator_A_31: props.data.filter(ans => ans.question === 61).length > 0 ? 
    props.data.filter(ans => ans.question === 61)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 61)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 61)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    year_indicator_A_31: props.data.filter(ans => ans.question === 63).length > 0 ? 
    props.data.filter(ans => ans.question === 63)[0].value : "",
   
    
    indicator_A_32: props.data.filter(ans => ans.question === 69).length > 0 ? 
    props.data.filter(ans => ans.question === 69)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 69)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 69)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    
    area_indicator_A_32: props.data.filter(ans => ans.question === 71).length > 0 ? 
    props.data.filter(ans => ans.question === 71).length === 1 ? 
    props.data.filter(ans => ans.question === 71)[0].value === "0" ? 
    `${t('result_public_entities')}` : 
     props.data.filter(ans => ans.question === 71)[0].value === "1" ? 
     `${t('result_private_companies')}` :
     props.data.filter(ans => ans.question === 71)[0].value === "2" ?
     `${t('result_private_public_partnerships')}` : 
   props.data.filter(ans => ans.question === 71)[0].value  === "3" ? 
    `${t('result_other')}` : "" : 
    props.data.filter(ans => ans.question === 71).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
    `${t('result_public_entities')}` : 
         res.value === "1" ? 
         `${t('result_private_companies')}` :
          res.value === "2" ?
          `${t('result_private_public_partnerships')}` : 
          `${t('result_other')}` ).join(" - ") : "",
    
    indicator_A_33: props.data.filter(ans => ans.question === 81).length > 0 ? 
    props.data.filter(ans => ans.question === 81)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 81)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 81)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    year_indicator_A_33: props.data.filter(ans => ans.question === 83).length > 0 ? 
    props.data.filter(ans => ans.question === 83)[0].value : "",
   
    area_indicator_A_33: props.data.filter(ans => ans.question === 84).length > 0 ?
    props.data.filter(ans => ans.question === 84).length === 1 ? 
    props.data.filter(ans => ans.question === 84)[0].value === "0" ? 
    `${t('result_farmers')}` : 
     props.data.filter(ans => ans.question === 84)[0].value === "1" ? 
     `${t('result_local_communities')}` :
     props.data.filter(ans => ans.question === 84)[0].value === "2" ?
     `${t('result_forest_owners')}` : 
   props.data.filter(ans => ans.question === 84)[0].value  === "3" ? 
    `${t('result_other_stakeholders')}` : "" : 
    props.data.filter(ans => ans.question === 84).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
     `${t('result_farmers')}` : 
          res.value === "1" ? 
          `${t('result_local_communities')}` :
           res.value === "2" ?
           `${t('result_forest_owners')}` : 
           `${t('result_other_stakeholders')}`).join(" - ") : "",
    
    indicator_A_41: props.data.filter(ans => ans.question === 95).length > 0 ? 
    props.data.filter(ans => ans.question === 95)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 95)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 95)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    year_indicator_A_41 : props.data.filter(ans => ans.question === 97).length > 0 ? 
    props.data.filter(ans => ans.question === 97)[0].value : "",
    
    area_indicator_A_41 : props.data.filter(ans => ans.question === 98).length > 0 ? 
    props.data.filter(ans => ans.question === 98).length === 1 ? 
    props.data.filter(ans => ans.question === 98)[0].value === "0" ? 
    `${t('result_farmers')}` : 
     props.data.filter(ans => ans.question === 98)[0].value === "1" ? 
     `${t('result_forest_owners')}` :
     props.data.filter(ans => ans.question === 98)[0].value === "2" ?
     `${t('result_private_sector')}` : 
   props.data.filter(ans => ans.question === 98)[0].value  === "3" ? 
    `${t('result_NGO')}` : 
    props.data.filter(ans => ans.question === 98)[0].value === "4" ? 
    `${t('result_gov_org')}` : 
     props.data.filter(ans => ans.question === 98)[0].value === "5" ? 
     `${t('result_research_org')}` :
     props.data.filter(ans => ans.question === 98)[0].value === "6" ?
     `${t('result_relevant_ministries')}` :
     props.data.filter(ans => ans.question === 98)[0].value === "7" ?
     `${t('result_other_stakeholders')}` :
     "" : 
     props.data.filter(ans => ans.question === 98).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
     `${t('result_farmers')}` : 
    res.value === "1" ? 
    `${t('result_forest_owners')}` :
     res.value === "2" ?
     `${t('result_private_sector')}` : 
    res.value === "3" ?
    `${t('result_NGO')}` :
     res.value === "4" ?
     `${t('result_gov_org')}` :
     res.value === "5" ?
     `${t('result_research_org')}` :
     res.value === "6" ?
     `${t('result_relevant_ministries')}` :
     `${t('result_other_stakeholders')}`
      ).join(" - ") : "",
    
    indicator_A_42: props.data.filter(ans => ans.question === 112).length > 0 ? 
    props.data.filter(ans => ans.question === 112)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 112)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 112)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    year_indicator_A_42: props.data.filter(ans => ans.question === 114).length > 0 ? 
    props.data.filter(ans => ans.question === 114)[0].value : "",

    area_indicator_A_43: props.data.filter(ans => ans.question === 115).length > 0 ? 
    props.data.filter(ans => ans.question === 115).length === 1 ? 
    props.data.filter(ans => ans.question === 115)[0].value === "0" ? 
    `${t('result_conservation_FGR')}` : 
     props.data.filter(ans => ans.question === 115)[0].value === "1" ? 
     `${t('result_use_FGR')}` :
     props.data.filter(ans => ans.question === 115)[0].value === "2" ?
     `${t('result_development_FGR')}` : "" :
     props.data.filter(ans => ans.question === 115).sort((a, b) => a.value - b.value).map(res => res.value === "0" ? 
      `${t('result_conservation_FGR')}` : 
          res.value === "1" ? 
          `${t('result_use_FGR')}` :
          `${t('result_development_FGR')}`
            ).join(" - ") : "",
    
    indicator_A_43: props.data.filter(ans => ans.question === 124).length > 0 ? 
    props.data.filter(ans => ans.question === 124)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 124)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 124)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    
    indicator_B_4_1_1: props.data.filter(ans => ans.question === 191).length > 0 ? 
    props.data.filter(ans => ans.question === 191)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 191)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 191)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,

    indicator_B_4_1_2: props.data.filter(ans => ans.question === 198).length > 0 ? 
    props.data.filter(ans => ans.question === 198)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 198)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 198)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,

    indicator_B_4_1_3: props.data.filter(ans => ans.question === 205).length > 0 ? 
    props.data.filter(ans => ans.question === 205)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 205)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 205)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,

    indicator_B_42: props.data.filter(ans => ans.question === 213).length > 0 ? 
    props.data.filter(ans => ans.question === 213)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 213)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 213)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,


    networks: props.data.filter(ans => ans.question === 215).length > 0 ? 
    props.data.filter(ans => ans.question === 215)[0].value : "",
    indicator_B_43: props.data.filter(ans => ans.question === 221).length > 0 ? 
    props.data.filter(ans => ans.question === 221)[0].value === "0" ? 
    `${t('legend_yes')}` : 
    props.data.filter(ans => ans.question === 221)[0].value === "1" ? 
    `${t('legend_initiated')}` : 
    props.data.filter(ans => ans.question === 221)[0].value === "2" ? `${t('legend_no')}` 
    : `${t('legend_not_available')}` 
    : `${t('legend_not_available')}`,
    organizations: props.data.filter(ans => ans.question === 223).length > 0 ? 
    props.data.filter(ans => ans.question === 223)[0].value : "",
          }] : [];




  return (
    <div>
      <CSVLink data={props.page === "allData" ? multiCountryDowloadableData : dowloadableData} headers={props.page === "allData" ? multiCountryColumns : columns} 
      filename={props.page === "allData" ? "All_records" : props.type === "species" ? 
        `${props.data[0].species}_Silvagris.csv` : `${props.country !== undefined ? props.page === "countryPage" ? props.country : 
        props.country !== undefined && props.country !== null && props.country.label !== undefined && props.country.label !== null ? props.country.label.replaceAll(' ', '_') : "" : ""}_Silvagris.csv`}>
      <Button  style={{backgroundColor: "#116AAB",  border:"1px solid #116AAB", width: props.page === "countryPage" ? "300px" : ''}}>
      <span style={{marginLeft: "0.5rem", marginRight: "0.5rem", verticalAlign: "middle"}}>{props.page === "countryPage" ? t('download_country_data') : t('download_data')}</span>
      {/* <img style={{verticalAlign: "middle"}} src={process.env.PUBLIC_URL + `/img/download.svg`} alt="download" /> */}
      </Button>
      </CSVLink>
    </div>
  );
}
export default DownloadCountryPoliciesResponses;